import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  async getTeamDetails(teamID) {
    return await picador.get('getTeamDetails', xhrPath.team({ teamID }));
  },
  async getTeamList(sort, sortDirection, filterString) {
    const params = { sort, sortDirection };
    if (filterString) {
      params.filterString = filterString;
    }
    return await picador.get('getTeamList', xhrPath.teamList, { params });
  },

  async updateTeam(teamID, updateTeamObj) {
    return await picador.put('updateTeam', xhrPath.team({ teamID }), updateTeamObj);
  },

  /**
   * TEAM MEMBERS
   */
  async inviteOppositionTeamLead(teamID, oppositionInvite) {
    return await picador.post(
      'inviteOppositionTeamLead',
      xhrPath.inviteOpposition(teamID),
      oppositionInvite
    );
  },
  async inviteCohortTeamLead(teamID, cohortInvite) {
    return await picador.post('inviteCohortTeamLead', xhrPath.inviteCohort(teamID), cohortInvite);
  },
  async inviteCopyOppositionTeamLead(citedOn, contestedDocumentId) {
    return await picador.get(
      'inviteCopyOppositionTeamLead',
      `/api/v1/team/${citedOn}/childOpposition/${contestedDocumentId}`
    );
  },
  async inviteTeamMember(teamID, teamMembersData) {
    return await picador.post('inviteTeamMember', xhrPath.teamMember(teamID), teamMembersData);
  },

  async addTeamMember(teamMemberData, teamID, teamMemberID) {
    return await picador.post(
      'addTeamMember',
      xhrPath.teamMember(teamID) + '/' + teamMemberID,
      teamMemberData
    );
  },

  async updateTeamMember(teamMemberData, teamMemberID) {
    return await picador.put(
      'updateTeamMember',
      xhrPath.teamMember() + '/' + teamMemberID,
      teamMemberData
    );
  },

  async removeTeamMembers(teamID, teamMemberIDs) {
    return await picador.delete(
      'removeTeamMembers',
      xhrPath.teamMember(teamID) + '/' + teamMemberIDs.join(',')
    );
  },

  async sendInvitation(teamMemberData) {
    return await picador.post('sendInvitation', xhrPath.invitation, {
      data: {
        member: teamMemberData,
      },
    });
  },

  async submitAnnotations(teamId) {
    return await picador.post('submitAnnotations', xhrPath.teamMemberSubmitAnnotations(teamId));
  },
};
